<template>

  <el-card class="h_100">
    <div slot="header" class="clearfix">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>修改密码</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="width: 400px; margin: 0 auto">
      <el-form label-width="80px">
        <el-form-item label="原密码">
          <el-input placeholder="请输入原密码" v-model="pwdParams.password"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input placeholder="请输入新密码" v-model="pwdParams.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input placeholder="请再次输入新密码" v-model="pwdParams.newPasswordAgain"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button  @click="handleChangePwd" type="primary">确定</el-button>
          <el-button @click="$router.go(-1)">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
  export default {
    name: "changePassword",
    data() {
      return {
        pwdParams: {
          id:JSON.parse(sessionStorage.getItem('user')).id,
          password:"",
          newPassword:"",
          newPasswordAgain:""
        },
        value: 0
      }
    },

    methods: {
      get() {
        this.value ++;
        console.log(this.value);
        if(this.value ==2){
          clearInterval(this.timer);
          this.$axios.get("/admin/adminLoginOut").then(res => {
            if(res.data.result == true){
              this.$message(res.data.info)
              this.isLogin = sessionStorage.clear();
              this.$router.push('/login');
            }
          })

        }
      },
      // 修改密码-确定
      handleChangePwd() {
        this.$axios
          .post("/admin/updateLoginPasswordV2", this.pwdParams)
          .then(res => {
            if (res.data.result) {
              this.$message.success(res.data.info);

              this.timer = setInterval(this.get, 1000);

              return
            }
            this.$message.error(res.data.info)
          });
      }
    }
  }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/changePassword.vue